import { Book } from '../../types';
import { createAmazonAffiliateLink } from '../../config/constants';

// Featured books are kept in memory since they're always needed
export const featuredBooks = {
  weeklyBook:   {
  id: 'weekly-1',
  title: 'All the Colors of the Dark',
  author: 'Chris Whitaker',
  summary: 'Set over decades, this gripping mystery follows a missing girl and the boy who never stopped looking for her. As time unravels secrets and reveals hard truths, the novel explores trauma, friendship, and the resilience of love. This emotional and layered story blends suspense with character-driven storytelling in a masterful way.',
  coverUrl: 'https://m.media-amazon.com/images/I/51XIhi8-ThL._SY445_SX342_PQ35_.jpg',
  amazonLink: 'https://amzn.to/43PpeY2',
  genre: ['Mystery'],
  mood: ['Intense & Dramatic', 'Dark & Atmospheric'],
  length: 'long'
  },
  
  currentlyReading: {
    id: 'current-1',
    title: 'Sunrise on the Reaping',
    author: 'Suzanne Collins',
    summary: "Set in the world of Panem decades before Katniss Everdeen's rebellion, this novel explores the events leading up to the 50th Hunger Games and the dark evolution of the Capitol's control.",
    coverUrl: 'https://m.media-amazon.com/images/I/71InK67X-sL._SY466_.jpg',
    amazonLink: 'https://amzn.to/4hZEVRw',
    genre: ['Fantasy', 'Dystopian'],
    mood: ['Dark & Atmospheric', 'Thought-provoking'],
    length: 'long'
  }
};

// Genre-specific book collections
const collections: Record<string, () => Promise<{ books: Book[] }>> = {
  fantasy: () => import('./fantasy'),
  scifi: () => import('./scifi'),
  mystery: () => import('./mystery'),
  literary: () => import('./literary'),
  romance: () => import('./romance'),
  historical: () => import('./historical'),
  contemporary: () => import('./contemporary'),
  horror: () => import('./horror'),
  'narrative-nonfiction': () => import('./narrative-nonfiction')
};

// Cache for loaded collections
const loadedCollections: Record<string, Book[]> = {};

// Load books by genre
export async function getBooksByGenre(genre: string): Promise<Book[]> {
  const normalizedGenre = genre.toLowerCase().replace(/[^a-z-]/g, '');
  
  // Return cached collection if available
  if (loadedCollections[normalizedGenre]) {
    return loadedCollections[normalizedGenre];
  }

  // Load collection if it exists
  const loader = collections[normalizedGenre];
  if (loader) {
    try {
      const { books } = await loader();
      loadedCollections[normalizedGenre] = books;
      return books;
    } catch (error) {
      console.error(`Error loading ${genre} books:`, error);
      return [];
    }
  }

  return [];
}

// Get all books (lazy loads all collections)
export async function getAllBooks(): Promise<Book[]> {
  try {
    const allCollections = await Promise.all(
      Object.values(collections).map(async (loader) => {
        const { books } = await loader();
        return books;
      })
    );
    return allCollections.flat();
  } catch (error) {
    console.error('Error loading all books:', error);
    return [featuredBooks.weeklyBook];
  }
}